import type { FC } from "react"
import { Link } from "react-router"

import { GuestNavigationMenu } from "@/components/guest-navigation-menu"
import { NavigationMenu } from "@/components/navigation-menu"
import { useCurrentUser } from "@/lib/useCurrentUser"
import { cn } from "@/lib/utils"
import { Logo } from "./Logo"
import { LanguageSelector } from "./language-selector"

interface Props {
  className?: string
}

export const Header: FC<Props> = ({ className }) => {
  const currentUser = useCurrentUser()

  return (
    <header
      className={cn("sticky top-0 z-40 flex h-12 items-center justify-between bg-white", className)}
    >
      <div className="flex h-full items-center pl-4 pr-2">
        <LanguageSelector />
      </div>

      <Link
        to="/"
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        aria-label="WarpMe"
      >
        <Logo />
      </Link>

      <div className="flex h-full items-center">
        {currentUser ? <NavigationMenu /> : <GuestNavigationMenu />}
      </div>
    </header>
  )
}
